import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import UrlHandlerApiService from "./url-handler.service";

const TasksApiService = {
  URL: "",
  async init() {
    Vue.use(VueAxios, axios);
    this.URL = await UrlHandlerApiService.getBaseUrl();
  },

  /**
   * StaticData:
   * taskPeriodicities: string[]; || Hourly / Daily / Weekly / Monthly / HalfYearly / Yearly / OneTime
   * taskRewardTypes: string[]; || OOBLEE_YELLOW / OOBYTE / CASH_WITHDRAWBAL / CASH_NON_WITHDRAWBAL
   * nextCodePreview: string;
   */

  /**
   * Metadata:
   * totalCount: number;
   * remainingCount: number;
   * hasMoreResults: boolean;
   */

  /**
   * TaskData:
   * rewards: TaskRewardData[];
   * id: number;
   * code: string;
   * displayName: string;
   * description: string;
   * periodicity: string;
   * isActive: boolean;
   * needToSendEmail: boolean;
   * createdAt: string;
   */

  /**
   * TaskRewardData:
   * id: string;
   * taskId: number;
   * rewardType: string;
   * value: number;
   * createdAt: string;
   */

  /**
   * @returns StaticData
   */
  updatePriorities(priorities) {
    return Vue.axios.put(this.URL + `api/promo/v1/admin/tasks/UpdatePriorities`, priorities);
  },

  /**
   * @returns StaticData
   */
  getStaticData() {
    return Vue.axios.get(this.URL + `api/promo/v1/admin/tasks/GetStaticData`);
  },

  /**
   *
   * @param {*} page number
   * @param {*} maxCount number
   * @returns Metadata & TaskData[]
   */
  getTaskList(params) {
    return Vue.axios.get(this.URL + `api/promo/v1/admin/tasks/GetList`, { params });
  },

  /**
   *
   * @param {*} id number
   * @returns TaskData
   */
  getTaskById(id) {
    return Vue.axios.get(this.URL + `api/promo/v1/admin/tasks/GetById/${id}`);
  },

  /**
   *
   * @param {*} task TaskData
   * @returns TaskData
   */
  createTask(task) {
    return Vue.axios.post(this.URL + `api/promo/v1/admin/tasks/Create`, task);
  },

  /**
   *
   * @param {*} task TaskData
   * @returns TaskData
   */
  updateTask(task) {
    return Vue.axios.put(this.URL + `api/promo/v1/admin/tasks/Update`, task);
  },

  /**
   *
   * @param {*} id number
   * @returns void
   */
  deleteTask(id) {
    return Vue.axios.delete(this.URL + `api/promo/v1/admin/tasks/Delete/${id}`);
  }
};

export default TasksApiService;
